import _ from "lodash";

import { colors } from "theme/palette";
import { toSentenceCase } from "utils/common";

import Skeleton from "components/Skeleton";
import Stack from "components/Stack";
import Text from "components/Text";

export interface IProgressBar {
  label?: string;
  progressData: Array<{
    label: string;
    percentage: number;
    color: string;
    icon: React.ReactNode;
  }>;
  sx?: React.CSSProperties;
}

const ProgressBar = ({ sx, label, progressData }: IProgressBar) =>
  _.isEmpty(progressData) ? (
    <Stack gap={0.5} sx={sx} data-testid="checklist-progress-section">
      {!_.isEmpty(label) && (
        <Text variant="labelSmall" color={colors.gray40} fontWeight={500}>
          {label}
        </Text>
      )}
      <Skeleton height="20px" width="100%" />
      <Skeleton height="8px" width="100%" />
    </Stack>
  ) : (
    <Stack gap={0.5} sx={sx} data-testid="checklist-progress">
      {!_.isEmpty(label) && (
        <Text variant="labelSmall" color={colors.gray40} fontWeight={500}>
          {label}
        </Text>
      )}

      <Stack gap={1} direction="row" flexWrap="wrap">
        {progressData
          .filter((item) => item.percentage > 0)
          .map((item) => (
            <Stack key={item.label} data-testid="checklist-progress-item">
              <Text
                variant="label"
                sx={{
                  fontWeight: 700,
                  color: item.color,
                }}
              >
                {toSentenceCase({ text: item.label })}:{" "}
                {item.percentage.toFixed(1)}%
              </Text>
              <Stack
                sx={{
                  border: `1px solid ${item.color}`,
                  width: "125px",
                  height: "8px",
                }}
              >
                <Stack
                  sx={{
                    height: "100%",
                    width: `${item.percentage}%`,
                    backgroundColor: item.color,
                    transition: "width 0.3s ease-in-out",
                  }}
                ></Stack>
              </Stack>
            </Stack>
          ))}
      </Stack>
    </Stack>
  );

export default ProgressBar;
